import { FC, ButtonHTMLAttributes, ReactNode } from 'react';
import { StyledToggleButton } from './styled';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
}

const ToggleButton: FC<Props> = ({ children, ...props }) => {
  return (
    <StyledToggleButton {...props}>
      {children}
    </StyledToggleButton>
  );
};

export default ToggleButton;
